module.exports = __webpack_public_path__ + "static/goias-goiania-66c5f7c5fa2c4987f8e7ee1e22c7f459.jpg";